<template>
  <div class="calendar-info-box">
    <div class="kol-info">
      <div class="img-box">
        <img :src="info.head_portrait" alt="">
      </div>
      <div class="info-box">
        <div class="kol-tit-box">
          <div class='kol-tit-l'>
            <div class='kol-nickname'>
              <span class="tip-content">{{info.type_name}}：</span>
              <el-link :href="info.long_url" target="_blank" type="primary" :underline="false">
                <el-tooltip class="item" effect="dark" :content="info.nickname" placement="top">
                  <span class="tip-content" style="max-width: 80px;">{{info.nickname}}</span>
                </el-tooltip>
              </el-link>
            </div>
             <div class='flex'><span class='w-100 text-r'>合作商单：</span>{{info.cpx_order_str}}</div> 
          </div>
          <p class="link-box page-pointer" @click="goFans(info)">查看粉丝画像</p>
        </div>
        <div class='flex'>
          <div class='w-300'>粉丝：{{info.fans}}</div>
          <div class='flex'><span class='w-100 text-r'>预计上线时间：</span>{{info.kol_time_begin}}</div>
        </div>
        <div class='kol-tip'><span class='c-f79'>任务完成数/全部任务数：</span>{{info.count_suc}}/{{info.count_all}}</div>
      </div>
    </div>

    <div class="deal-list">
      <el-table
        :data="info.kol_deal"
        :header-cell-style="{background: '#f9f9f9', color: '#333',}"
      >
        <el-table-column
          label="带货商品"
          width="360"
        >
          <template slot-scope="scope">
            <div class="goods-box">
              <div class="">
                <img class='page-goods-img' :src="scope.row.goods_img" alt="">
              </div>
              <div class="goods-info">
                <el-link :href="scope.row.goods_link" target="_blank" type="primary" :underline="false">{{scope.row.goods_name}}</el-link>
                <div>
                  商城：
                  <span v-if="scope.row.platform == 'taobao'">【淘宝】</span>
                  <span v-if="scope.row.platform == 'tianmao'">【天猫】</span>
                  <span v-if="scope.row.platform == 'jingdong'">【京东】</span>
                  <span v-if="scope.row.platform == 'suning'">【苏宁】</span>
                  <span v-if="scope.row.platform == 'kaola'">【考拉】</span>
                  <span v-if="scope.row.platform == 'douyin'">【抖音小店】</span>
                  <span v-if="scope.row.platform == 'weipinhui'">【唯品会】</span>
                  <span v-if="scope.row.platform == 'wangyiyanxuan'">【网易严选】</span>
                </div>
                <p>商品ID：{{scope.row.goods_id}}</p>
                <p>店铺名称：{{scope.row.store_name}}</p>
                <p>类目：{{scope.row.smzdm_category_1_name}}/{{scope.row.smzdm_category_2_name}}/{{scope.row.smzdm_category_3_name}}</p>
                <p>日常价格：¥{{scope.row.daily_price}}</p>
                <p>达人专属价：¥{{scope.row.kol_special_price}}</p>
                <p>预期佣比：{{Number(scope.row.commission_rate)}}%</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="合作商单"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <p>商单编号：{{scope.row.cxorid}}</p>
              <p>商单标题：{{scope.row.cpx_order_name}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="合作信息"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <p>是否需要寄样：{{scope.row.is_send_samples == 1 ? '是' : '否'}}</p>
              <p>
                推广形式：
                {{scope.row.promote_video == 2 ? '短视频' : ''}}
                {{scope.row.promote_live == 2 ? '直播' : ''}}
                {{scope.row.promote_live_special == 2 ? '专场' : ''}}
                {{scope.row.promote_other == 2 ? '其他' : ''}}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="时间"
          width=""
        >
          <template slot-scope="scope">
            <div>
              <p>创建：{{scope.row.create_time}}</p>
              <p>达人档期：<div>{{scope.row.begin_time}}-</div>{{scope.row.end_time}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="进展"
          width="120"
        >
          <template slot-scope="scope">
            <div class="sample-list">
              <p :class="scope.row.is_sample_info == 2 ? 'success' : ''" v-if='scope.row.is_send_samples==1'>
                <el-link :type="scope.row.is_sample_info == 2 ? 'success' : 'info'" :underline="false">
                  <span>填写寄样信息</span>
                  <i class="el-icon-check"></i>
                </el-link>
              </p>
              <p :class="scope.row.is_sample_suc == 2 ? 'success' : ''" v-if='scope.row.is_send_samples==1'>
                <el-link :type="scope.row.is_sample_suc == 2 ? 'success' : 'info'" :underline="false">
                  <span>寄样</span>
                  <i class="el-icon-check"></i>
                </el-link>
              </p>
              <p :class="scope.row.is_receive_suc == 2 ? 'success' : ''" v-if='scope.row.is_send_samples==1'>
                <el-link :type="scope.row.is_receive_suc == 2 ? 'success' : 'info'" :underline="false">
                  <span>收样</span>
                  <i class="el-icon-check"></i>
                </el-link>
              </p>
              <p :class="scope.row.is_result_online == 2 ? 'success' : ''">
                <el-link :type="scope.row.is_result_online == 2 ? 'success' : 'info'" :underline="false">
                  <span>作品上线</span>
                  <i class="el-icon-check"></i>
                </el-link>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="任务状态"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <p>{{check_status[scope.row.check_status]}}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 粉丝画像 -->
    <portraitfans v-if="isfans" :fansObj="fansObj" @closeMask ='isfans = false'></portraitfans>
  </div>
</template>

<script>
import portraitfans from "@/views/my/portrait_fans.vue"
import utils from '@/utils/util';
export default {
  name: "usercalendarinfo",
  components: {
    portraitfans
  },
  data() {
    return {
      isfans: false,
      fansObj: {},
      // 入参
      klurid: '',
      day: '',
      month: '',
      // 出参
      info: {},

      // 字典表
      check_status: {
        0: '进行中',
        1: '合作成功',
        2: '合作失败',
        3: '待审核',
        4: '待发货',
        5: '待收货',
        6: '待交付',
        7: '交付待确认',
        8: '已拒绝',
        9: '逾期',
        10: '已取消',
        11: '待填写寄样信息',
        12: '待效果回传',
      },
    };
  },
  created() {
    // 入参
    this.klurid = this.$route.query.klurid;
    this.day = this.$route.query.day;
    this.month = this.$route.query.month;
    this.getData();
  },
  mounted() {},
  methods: {
    getData() {
      let _that = this;
      this.$http({
        method: 'GET',
        params: {
          month: this.month,
          day: this.day,
          klurid: this.klurid,
        },
        url: '/home/getCalendarProjectKolGoodsList',
      }).then(res => {
        if (res.code !== 1) {
          console.error(res.msg);
          return false;
        }
        // 数据格式化
        res.data && _that.formatInfo(res.data);
      }).catch(error => {
        console.error(error);
      });
    },
    formatInfo(data) {
      // 把对应达人信息摘出来
      let info = data[this.day.slice(-2)][this.klurid];

      if (info) {
        // 达人详情拍平
        this.info = {
          ...info,
          ...info.kol_user,
        };
        // 上线时间格式化
        this.kol_deal = info.kol_deal.map(item => {
          item.begin_time =item.kol_time_begin.slice(0,10);
          item.end_time = item.kol_time_end.slice(0,10)
          return item;
        });
        // 合作商单存字符串
        this.info.cpx_order_str = this.info.cpx_order.join('、');
        // 粉丝过万处理
        this.info.fans = info.kol_user.fans > 9999 ? this.million(info.kol_user.fans) + 'w' : info.kol_user.fans;
        // 上线时间取值到天
        this.info.kol_time_begin = info.kol_time_begin.slice(0, 10);
      }
    },
    // 粉丝画像
    goFans(info) {
      this.isfans = true;
      this.fansObj = info;
      // let luopan_id = info.luopan_id;
      // let nickname = info.nickname;
      // let type = info.type
      // this.$router.push({
      //   path: "/my/usercalendar/portrait_fans",
      //   query: {
      //     type,
      //     luopan_id,
      //     nickname,
      //   }
      // })
    },
    //过万处理
    million(value) {
      let num;
      if(value > 9999){
        num = Number((value/10000).toFixed(1))
        return num;
      }else{
        return value
      }
    },
  },
};
</script>
<style scoped>
p {
  margin: 0 0 8px;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.calendar-info-box {
  padding: 16px 0;
  font-size: 14px;
}
.img-box {
  margin-right: 16px;
}
.img-box img {
  width: 100px;
  height: 100px;
}
.kol-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  color: #333;
  font-size: 14px;
}
.kol-desc-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.kol-info .kol ,.kol-info .order {
  flex: 1 1;
  background: #f6f6f6;
  margin: 4px;
  padding: 8px;
}
.kol-info .kol {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.kol-info .kol .tip-content {
  display: inline-block;
  overflow:hidden; 
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}
.kol-info .kol .desc-box {
  flex: 1;
}
.kol-info .link-box {
  text-align: right;
  float: right;
}
.kol-info .info-box {
  flex: auto;
  width: 100%;
}
.kol-info .kol-desc-box li {
  min-width: 260px;
  line-height: 20px;
  margin-top: 8px;
}
.kol-info .kol-desc-box li span {
  display: inline-block;
  width: 98px;
  text-align: right;
}
.kol-info .kol-desc-box .adid-list li span {
  width: 84px;
}
.kol-info .kol-desc-box .order-list li p {
  background: rgba(245, 108, 108, .1);
  border-radius: 100px;
  color: #F79393;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  width: 285px;
}

.goods-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.goods-box .goods-name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
.goods-img {
  margin: 8px;
}
.goods-img img {
  width: 100px;
  height: 100px;
}
.sample-list p span {
  font-size: 14px;
}
.sample-list p.success i {
  display: inline;
}
.sample-list p i {
  font-size: 14px;
  display: none;
}
.kol-tit-box{
 display: flex;
 justify-content: space-between;
 align-items: center;
}
.kol-tit-l{
  display: flex;
  align-items: center;
}
.tip-content{
  /* width:84px; */
  text-align: right;
}
.deal-list{
  margin-top:20px;
}
.flex{
  display: flex;
}
.w-300{
  width:300px;
}
.w-100{
  width:100px;
}
.text-r{
  text-align: right;
}
.kol-tip{
  width:285px;
  height:20px;
  background: #fef0f0;
  border-radius: 10px;
  text-align: center;
  line-height:20px;
  font-size:12px;
  margin-left:300px;
  margin-top:14px;
  color:#F56C6C;
}
.c-f79{
  color:#F79393;
}
.kol-nickname{
  display: flex;
  width:300px;
  align-items: center;
}
</style>
<style>
.sample-list .el-link--inner{
  cursor:default;
}
</style>